/* eslint-disable camelcase */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Button, Grid, IconButton, TableCell } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Controller } from '../../../common/Controller';
import { SubEntityCard } from '../../../common/components/SubEntity/SubEntityCard';
import { CommonTheme } from '../../../styles/Styles';
import { SubEntityList } from '../../../common/components/SubEntity/SubEntityList';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import TableCard from '../../../common/components/tables/TableCard';
import { AppHelper } from '../../../helpers/AppHelper';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { CRMHelper } from '../../../helpers/CRMHelper';

export function generateRuleJobsReport({ruleJobs, ruleActions, wideCells}) {
  if(!ruleJobs || ruleJobs.length === 0) {
    return {}
  }

  const reportHeaders = ['Index', 'Info', 'Status','Actions']
  const hiddenColumns = [3]
  const textColumnIndices = [0,1,2]

  const actionResultHasWaError = (actionResult) => {
    if (!actionResult || !actionResult.waResponse || !Array.isArray(actionResult.waResponse.items)) {
      return false
    }
    return actionResult.waResponse.items.some((item) => item && item.error)
  }

  const getWaErrorMessage = (actionResult) => {
    if (!actionResult || !actionResult.waResponse || !Array.isArray(actionResult.waResponse.items)) {
      return ''
    }
    const erroredItem = actionResult.waResponse.items.find((item) => item && item.error)
    if (!erroredItem) {
      return ''
    }
    const error = erroredItem.error
    const payload = error && error.payload
    if (payload) {
      if (payload.errorDetail && payload.errorDetail.message) {
        return payload.errorDetail.message
      }
      if (payload.message) {
        return payload.message
      }
    }
    if (error && error.message) {
      return error.message
    }
    return 'WhatsApp sending failed'
  }

  const getActionResultTip = (actionResult, index) => {
    if(!actionResult) {
      return null
    }
    const actionState = actionResult.state || 'UNKNOWN'
    let actionInfo = ''
    if(actionState === 'COMPLETED' && actionResult.executionMs) {
      actionInfo = Helper.formatTimestamp(actionResult.executionMs)
    } else if((actionState === 'SCHEDULED' || actionState === 'LIVE') && actionResult.whenMs) {
      actionInfo = Helper.formatTimestamp(actionResult.whenMs)
    } else if((actionState === 'ERROR' || actionState === 'SKIPPED') && (actionResult.errorMessage || actionResult.reason)) {
      actionInfo = (actionResult.errorMessage || actionResult.reason).replace(/_/g, ' ')
    } else if(actionResult.whenMs) {
      actionInfo = Helper.formatTimestamp(actionResult.whenMs)
    }
    const waErrorMessage = getWaErrorMessage(actionResult)
    return `Action ${index + 1}: ${actionState}${actionInfo ? ` (${actionInfo})` : ''}${waErrorMessage ? ` - ${waErrorMessage}` : ''}`
  }

  const data = ruleJobs.map((job, index)=>{
    if(job) {
      let whenMs = null
      const actionResultsTip = []
      let actionError = ''

      if(job.actionResults) {
        const sortedActionResults = Object.entries(job.actionResults)
          .sort((a, b) => {
            const actionIdA = a[0]
            const actionIdB = b[0]
            const actionA = ruleActions && ruleActions[actionIdA]
            const actionB = ruleActions && ruleActions[actionIdB]
            const orderA = actionA && actionA.order ? parseInt(actionA.order, 10) : 0
            const orderB = actionB && actionB.order ? parseInt(actionB.order, 10) : 0

            if(orderA !== orderB) {
              return orderA - orderB
            }

            if(actionIdA < actionIdB) return -1
            if(actionIdA > actionIdB) return 1
            return 0
          })
          .map((entry) => entry[1])

        if(sortedActionResults && sortedActionResults.length > 0) {
          whenMs = sortedActionResults[0].whenMs
          actionError = sortedActionResults.reduce((p, c) => {
            const actionState = c && c.state
            if (actionState === 'ERROR' || p === 'ERROR') {
              return 'ERROR'
            }
            if (actionState === 'SKIPPED') {
              return 'SKIPPED'
            }
            if (p) {
              return p
            }
            return actionResultHasWaError(c) ? 'ERROR' : ''
          }, '')
          sortedActionResults.forEach((actionResult, actionIndex) => {
            const actionResultTip = getActionResultTip(actionResult, actionIndex)
            if(actionResultTip) {
              actionResultsTip.push(actionResultTip)
            }
          })
        }
      }

      if(actionError !== 'ERROR' && actionResultHasWaError(job)) {
        actionError = 'ERROR'
        const jobWaErrorMessage = getWaErrorMessage(job)
        if(jobWaErrorMessage && actionResultsTip.length === 0) {
          actionResultsTip.push(`${job.state || 'EXECUTED'} - ${jobWaErrorMessage}`)
        }
      }
      return({
        index: index + 1,
        entity: {
          name: job.entityName || (job.entityId ? CRMHelper.getUserIdFromEnityId(job.entityId) : ''),
          createdTs: job.createdTs || job.createdts
        },
        status: {
          state: job.state,
          whenMs: whenMs,
          actionResultsTip,
          actionError,
        },
        data: job
      })
    }
  }).filter(a => !!a)


  const wideCellClass = wideCells
    ? css(Styles.cellBody, Styles.firstColumn, Styles.cellWidthWide, Styles.cellWidthUncapped)
    : css(Styles.cellBody, Styles.firstColumn, Styles.cellWidthWide)

  return {
    headers: reportHeaders,
    rows: data.map(item => Object.values(item)),
    textColumnIndices: textColumnIndices,
    hiddenColumnIndices: hiddenColumns,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(cellValue && columnIndex) {
        if(columnIndex === 1) {
          return(
            <TableCell key={columnIndex} className={wideCellClass}>
              <div className={css(Styles.spanValue, Styles.infoCell)}>
                {cellValue.name && <span className={css(Styles.infoField)}>{cellValue.name}</span>}
                {cellValue.createdTs && <span className={css(Styles.line2)}>Created: {Helper.formatTimestamp(cellValue.createdTs)}</span>}
              </div>
            </TableCell>
          )
        }
        if(columnIndex === 2) {
          return(
            <TableCell key={columnIndex} className={wideCellClass}>
              <div className={css(Styles.spanValue, Styles.infoCell)}>
                {cellValue.state && <span className={css(Styles.statusValueRow)}>
                  {cellValue.actionError && <span className={css(cellValue.actionError === 'ERROR' ? Styles.errorDot : Styles.warningDot)} />}
                  <span className={css(Styles.infoField)}>{cellValue.state}</span>
                  {Array.isArray(cellValue.actionResultsTip) && cellValue.actionResultsTip.length > 0 && <Tooltip
                    title={<div>{cellValue.actionResultsTip.map((currentTip, tipIndex) => <div key={tipIndex}>{currentTip}</div>)}</div>}
                    classes={{ popper: css(Styles.tooltip) }}
                  >
                    <i className='material-icons-outlined' style={{ fontSize: 14, color: '#7d7d7d', cursor: 'pointer', marginLeft: 5, marginTop: 0, alignSelf: 'center' }}>info</i>
                  </Tooltip>}
                </span>}
              </div>
            </TableCell>
          )
        }
      }
      return null
    }
  }
}

/**
 * Drops all keys containing "__", maps suffixed action fields onto bare keys for the rules API,
 * and omits REMOVE_ATTRS on add. Only applies action-specific consolidation when entityAttrName is "actions".
 * Strips any key from REMOVE_ATTRS that is still present on the payload so the BE never SET+REMOVE the same path.
 */
export function sanitizeAutomationDetailFormPayload(formData, formType) {
  const isAdd = formType === 'add'
  const out = {}
  Object.keys(formData || {}).forEach((key) => {
    if (key.indexOf('__') !== -1) {
      return
    }
    out[key] = formData[key]
  })
  if (isAdd) {
    delete out.REMOVE_ATTRS
  }
  if (formData && formData.entityAttrName === 'actions') {
    const iType = formData.iType
    if (iType === 'SEND_WHATSAPP') {
      const waContentId = formData.waContentId
      const perKey = waContentId ? `wabaNumber__${waContentId}` : ''
      const fromPerContent = perKey && Object.prototype.hasOwnProperty.call(formData, perKey)
        ? formData[perKey]
        : undefined
      const fromBare = formData.wabaNumber
      if (fromPerContent !== undefined && fromPerContent !== null && fromPerContent !== '') {
        out.wabaNumber = fromPerContent
      } else if (fromBare !== undefined && fromBare !== null && fromBare !== '') {
        out.wabaNumber = fromBare
      } else if (fromPerContent !== undefined && fromPerContent !== null) {
        out.wabaNumber = fromPerContent
      } else {
        out.wabaNumber = fromBare !== undefined && fromBare !== null ? fromBare : ''
      }
    }
    if (iType === 'UPDATE_CONTACT' && formData.attrName) {
      const attrName = formData.attrName
      const avKey = `attrValue__${attrName}`
      if (Object.prototype.hasOwnProperty.call(formData, avKey)) {
        out.attrValue = formData[avKey]
      }
      const opKey = `operator__${attrName}`
      if (Object.prototype.hasOwnProperty.call(formData, opKey)) {
        out.operator = formData[opKey]
      }
      const valKey = `values__${attrName}`
      if (Object.prototype.hasOwnProperty.call(formData, valKey)) {
        out.values = formData[valKey]
      }
    }
  }
  if (!isAdd && Array.isArray(out.REMOVE_ATTRS) && out.REMOVE_ATTRS.length) {
    out.REMOVE_ATTRS = out.REMOVE_ATTRS.filter((k) => !Object.prototype.hasOwnProperty.call(out, k))
    if (!out.REMOVE_ATTRS.length) {
      delete out.REMOVE_ATTRS
    }
  }
  return out
}

export class AutomationDetail extends BaseEntityPageSlixta {
  constructor(props) {
    super(props);
    this.customSubmit = this.customSubmit.bind(this)
    this.onCompleteAction = this.onCompleteAction.bind(this)
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = 'Automation Detail'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.ruleId = this.props.match.params.id
    this.staffUserId = Controller.get().getUserId()
    this.limit = 200
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId)
    this.staffUsers = []
    this.subOrgs = []
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('backToAutomations'), to: this.baseRoute() + '/automations', type: 'button', icon: 'arrow_back_ios' },
    ]
    this.toFetch = [
      { key: 'rule', ms: this.ms, method: 'GET', paths: ['rules', this.ruleId], queryParams: { orgId: this.orgId, pb: 'fieldDef,fieldDefRuleFilters,fieldDefRuleStops,fieldDefRuleActions' } },
      { key: 'ruleJobs', ms: this.ms, method: 'GET', paths: ['rulejobs'], queryParams: { orgId: this.orgId, ruleId: this.ruleId, limit:this.limit} },
      { key: 'usersORG', ms: this.ms, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } },
    ]
    if (this.teamsEnabled) {
      this.toFetch.push({ key: 'suborgs', ms: this.ms, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } })
    }
    this.apiData = {
      orgId: this.orgId
    }
    this.pageKey = this.pageTitle
    this.noAdd = true
    this.ruleFiltersTableHeadersMap = {
      Order: (current) => current.order,
      On : (current) => {
        let attrType = current && current.payloadField
        if(attrType && this.fieldDefRuleFilters) {
          const payloadField = Helper.getField(this.fieldDefRuleFilters, 'payloadField')
          if(payloadField && payloadField.options && payloadField.options.length > 0) {
            const operator = payloadField.options.find(x => x.key === attrType)
            if(operator && operator.label) {
              attrType = operator.label
            }
          }
        }
        return attrType
      },
      Attribute : (current) => {
        const key = current && current.payloadSubField
        return this.resolveSubEntityFieldOptionLabel(this.fieldDefRuleFilters, 'payloadSubField', key)
      },
      Operator: (current) => {
        let op = current && current.op
        if(op && this.fieldDefRuleFilters) {
          const operatorField = Helper.getField(this.fieldDefRuleFilters, 'op')
          if(operatorField && operatorField.options && operatorField.options.length > 0) {
            const operator = operatorField.options.find(x => x.key === op)
            if(operator && operator.label) {
              op = operator.label
            }
          }
        }
        return op
      },
      Value: (current) => this.formatRuleConditionValueDisplay(current),
    }
    this.ruleActionsTableHeadersMap = {
      Order: (current) => current.order,
      Action: (current) => {
        let actionType = current && current.iType
        if(actionType && this.fieldDefRuleActions) {
          const actionTypeField = Helper.getField(this.fieldDefRuleActions, 'iType')
          if(actionTypeField && actionTypeField.options && actionTypeField.options.length > 0) {
            const actionTypeOption = actionTypeField.options.find(x => x.key === actionType)
            if(actionTypeOption && actionTypeOption.label) {
              actionType = actionTypeOption.label
            }
          }
        }

        let line2 = null
        if(actionType === 'SEND_WHATSAPP' && current && current.waContentId && this.fieldDefRuleActions) {
          const waContentIdField = Helper.getField(this.fieldDefRuleActions, 'waContentId')
          if(waContentIdField && waContentIdField.options && waContentIdField.options.length > 0) {
            const waContentIdOption = waContentIdField.options.find(x => x.key === current.waContentId)
            if(waContentIdOption && waContentIdOption.label) {
              line2 = waContentIdOption.label
            }
          }
        } else if(actionType === 'UPDATE_CONTACT' && current && current.attrName && this.fieldDefRuleActions) {
          line2 = current.attrName
          const attrNameField = Helper.getField(this.fieldDefRuleActions, 'attrName')
          if(attrNameField && attrNameField.options && attrNameField.options.length > 0) {
            const attrNameOption = attrNameField.options.find(x => x.key === current.attrName)
            if(attrNameOption && attrNameOption.label) {
              line2 = attrNameOption.label
            }
          }
        } else if(current && current.iType === 'ROUTE_LEAD' && current.routingStrategy && this.fieldDefRuleActions) {
          line2 = current.routingStrategy
          const routingStrategyField = Helper.getField(this.fieldDefRuleActions, 'routingStrategy')
          if(routingStrategyField && routingStrategyField.options && routingStrategyField.options.length > 0) {
            const routingStrategyOption = routingStrategyField.options.find(x => x.key === current.routingStrategy)
            if(routingStrategyOption && routingStrategyOption.label) {
              line2 = routingStrategyOption.label
            }
          }
        } else if(current && current.iType === 'ENROL_IN_SEQUENCE' && current.campaignId && this.fieldDefRuleActions) {
          const campaignIdField = Helper.getField(this.fieldDefRuleActions, 'campaignId')
          if(campaignIdField && campaignIdField.options && campaignIdField.options.length > 0) {
            const campaignIdOption = campaignIdField.options.find(x => x.key === current.campaignId)
            if(campaignIdOption && (campaignIdOption.label || campaignIdOption.text)) {
              line2 = campaignIdOption.label || campaignIdOption.text
            }
          }
          if (!line2) {
            line2 = current.campaignId
          }
        }
        return(<div>
          <span>{actionType}</span>
          <br/>
          <span className={css(Styles.line2)}>{line2}</span>
          <br/>
        </div>)
      },
      Schedule: (current) => {
        let scheduleType = current && current.scheduleType
        if(scheduleType && this.fieldDefRuleActions) {
          const scheduleTypeField = Helper.getField(this.fieldDefRuleActions, 'scheduleType')
          if(scheduleTypeField && scheduleTypeField.options && scheduleTypeField.options.length > 0) {
            const scheduleTypeOption = scheduleTypeField.options.find(x => x.key === scheduleType)
            if(scheduleTypeOption && scheduleTypeOption.label) {
              scheduleType = scheduleTypeOption.label
            }
          }
        }
        return scheduleType
      },
      'Schedule Time': (current) => {
        if (!current || !current.scheduleMs) {
          return
        }
        if (current.scheduleType === 'ABSOLUTE_UTC_TIME') {
          return Helper.formatTimestamp(current.scheduleMs)
        }
        const duration = Helper.formatDurationExact(Math.abs(current.scheduleMs));
        return current.scheduleMs < 0 ? `before ${duration}` : `after ${duration}`;
      }
    }
    this.ruleStopsTableHeadersMap = {
      Order: (current) => current.order,
      Event: (current) => {
        let eventType = current && current.eventType
        if(eventType && this.fieldDefRuleStops) {
          const eventTypeField = Helper.getField(this.fieldDefRuleStops, 'eventType')
          if(eventTypeField && eventTypeField.options && eventTypeField.options.length > 0) {
            const eventTypeFieldOption = eventTypeField.options.find(x => x.key === eventType)
            if(eventTypeFieldOption && eventTypeFieldOption.label) {
              eventType = eventTypeFieldOption.label
            }
          }
        }
        return eventType
      },
      On : (current) => {
        let attrType = current && current.payloadField
        if(attrType && this.fieldDefRuleStops) {
          const payloadField = Helper.getField(this.fieldDefRuleStops, 'payloadField')
          if(payloadField && payloadField.options && payloadField.options.length > 0) {
            const operator = payloadField.options.find(x => x.key === attrType)
            if(operator && operator.label) {
              attrType = operator.label
            }
          }
        }
        return attrType
      },
      Attribute : (current) => {
        const key = current && current.payloadSubField
        return this.resolveSubEntityFieldOptionLabel(this.fieldDefRuleStops, 'payloadSubField', key)
      },
      Operator: (current) => {
        let op = current && current.op
        if(op && this.fieldDefRuleStops) {
          const operatorField = Helper.getField(this.fieldDefRuleStops, 'op')
          if(operatorField && operatorField.options && operatorField.options.length > 0) {
            const operator = operatorField.options.find(x => x.key === op)
            if(operator && operator.label) {
              op = operator.label
            }
          }
        }
        return op
      },
      Value: (current) => this.formatRuleConditionValueDisplay(current),
    }
    this.executionStatusTableCellWidths = {
      Index: Styles.cellWidthSmall,
      Info: Styles.cellWidthWide,
      Status: Styles.cellWidthWide,
      Actions: Styles.cellWidthSmall,
    }

  }

  resolveSubEntityFieldOptionLabel(fieldDef, fieldKey, storedKey) {
    if (!storedKey || !fieldDef) {
      return storedKey
    }
    const fields = Helper.getFields(fieldDef, fieldKey)
    if (fields.length === 0) {
      return storedKey
    }
    const uniqueOptionKeys = new Set()
    const optionByLookupKey = new Map()
    for (const field of fields) {
      if (!field || !Array.isArray(field.options) || field.options.length === 0) {
        continue
      }
      for (const opt of field.options) {
        if (!opt) {
          continue
        }
        const keysForOpt = []
        if (opt.key !== undefined && opt.key !== null) {
          keysForOpt.push(opt.key)
        }
        if (opt.value !== undefined && opt.value !== null) {
          keysForOpt.push(opt.value)
        }
        for (const k of keysForOpt) {
          const s = String(k)
          uniqueOptionKeys.add(s)
          if (!optionByLookupKey.has(s)) {
            optionByLookupKey.set(s, opt)
          }
        }
      }
    }
    const lookup = String(storedKey)
    if (!uniqueOptionKeys.has(lookup)) {
      return storedKey
    }
    const opt = optionByLookupKey.get(lookup)
    if (!opt) {
      return storedKey
    }
    const resolved = opt.label || opt.text || opt.title
    if (resolved !== undefined && resolved !== null && String(resolved).trim() !== '') {
      return resolved
    }
    return storedKey
  }

  formatRuleConditionValueDisplay(current) {
    if (!current || current.value === undefined || current.value === null || current.value === '') {
      return
    }
    const raw = current.value
    if (Array.isArray(raw)) {
      return raw
        .filter(item => item !== undefined && item !== null)
        .map(item => String(item).trim())
        .filter(item => item !== '')
        .join(', ')
    }
    const v = typeof raw === 'string' ? raw.trim() : raw
    if (v === '{{CURRENT_TS}}') {
      return 'CURRENT DATE'
    }
    const attr = current.payloadSubField
    if (attr === 'subOrgId') {
      if (v === 'unassigned') {
        return '[UNASSIGNED]'
      }
      const team = Array.isArray(this.subOrgs) && this.subOrgs.find(s => s && s.id === v)
      if (team && team.title) {
        return team.title
      }
      return raw
    }
    if (attr === 'assignee') {
      if (v === 'unassigned' || v === '__UNASSIGNED__') {
        return '[UNASSIGNED]'
      }
      const u = CRMHelper.findStaffByAssignee(this.staffUsers, v)
      if (u) {
        return u.title || Helper.formatName(u)
      }
      return raw
    }
    return raw
  }

  async onFetchSuccess(results) {
    this.rule = this.getResult(results, 'rule')
    const usersOrgRes = this.getResult(results, 'usersORG')
    this.staffUsers = (usersOrgRes && Array.isArray(usersOrgRes.items)) ? usersOrgRes.items : []
    if (this.teamsEnabled) {
      const suborgsRes = this.getResult(results, 'suborgs')
      this.subOrgs = (suborgsRes && Array.isArray(suborgsRes.items)) ? suborgsRes.items : []
    } else {
      this.subOrgs = []
    }
    if (this.rule && this.rule.title) {
      this.pageTitle = this.rule.title
      this.pageKey = this.rule.title
    } else {
      this.pageTitle = 'Automation Detail'
      this.pageKey = this.pageTitle
    }
    this.fieldDef =  this.rule &&  this.rule.fieldDef
    if(this.fieldDef) {
      const automationAdvancedFieldsEnabled = AppHelper.isSettingEnabled(this.orgId, 'AUTOMATIONS_ADVANCED_FIELDS')
      const fieldDefCopy = JSON.parse(JSON.stringify(this.fieldDef))
      if (fieldDefCopy.steps && fieldDefCopy.steps[0] && Array.isArray(fieldDefCopy.steps[0].fields)) {
        fieldDefCopy.steps[0].fields = fieldDefCopy.steps[0].fields.filter((field) => {
          if (!field.advanced) {
            return true
          }
          const matchKey = field._uiKey ? field._uiKey : field.key
          if (matchKey === 'filtersOp' || matchKey === 'stopsOp') {
            return false
          }
          return automationAdvancedFieldsEnabled
        })
      }
      this.fieldDef = fieldDefCopy
      const iTypeField = Helper.getField(this.fieldDef, 'iType')
      if(iTypeField) {
        iTypeField.hidden = true
      }
      const eventTypeField = Helper.getField(this.fieldDef, 'eventType')
      if(eventTypeField) {
        eventTypeField.label = 'Trigger Event'
        eventTypeField.placement = 'left'
      }
    }
    this.fieldDefRuleFilters =  this.rule &&  this.rule.fieldDefRuleFilters
    this.ruleFilters = (this.rule && this.rule.filters) ? Object.values(this.rule.filters) : []
    this.fieldDefRuleActions =  this.rule &&  this.rule.fieldDefRuleActions
    this.ruleActions = (this.rule && this.rule.actions) ? Object.values(this.rule.actions) : []
    this.fieldDefRuleStops =  this.rule &&  this.rule.fieldDefRuleStops
    this.ruleStops = (this.rule && this.rule.stops) ? Object.values(this.rule.stops) : []
    CRMHelper.setUniqueAssigneeOptionsOnFieldDef(this.fieldDefRuleFilters, this.staffUsers)
    CRMHelper.setUniqueAssigneeOptionsOnFieldDef(this.fieldDefRuleActions, this.staffUsers)
    CRMHelper.setUniqueAssigneeOptionsOnFieldDef(this.fieldDefRuleStops, this.staffUsers)
    const ruleJobsResult = this.getResult(results, 'ruleJobs')
    this.ruleJobs = (ruleJobsResult && Array.isArray(ruleJobsResult.items)) ? ruleJobsResult.items : []
    this.ruleJobsNextPage = ruleJobsResult && ruleJobsResult.nextPage
    this.ruleActions = (this.rule && this.rule.actions) ? Object.values(this.rule.actions) : []
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    if (this.rule.state === 'DISABLED') {
      this.headerActions.unshift({
        label: 'Start',
        tooltip: 'Start',
        icon: 'send',
        onClick: () => this.updateRuleState(this.rule, 'LIVE')
      })
    }
    if (this.rule.state === 'LIVE') {
      this.headerActions.unshift({
        label: 'Pause',
        tooltip: 'Pause',
        icon: 'pause',
        onClick: () => this.updateRuleState(this.rule, 'DISABLED')
      })
    }
  }

  renderAboveTable() {
    const report = this.ruleJobs && generateRuleJobsReport({ruleJobs:this.ruleJobs, ruleActions: this.rule && this.rule.actions})
    const canAddSubEntities = true
    const hideExecutionStatus = this.rule && this.rule.state === 'DISABLED' && (!this.ruleJobs || this.ruleJobs.length === 0)

    let ruleItem = {}
    if(this.rule) {
      ruleItem = JSON.parse(JSON.stringify(this.rule))
    }

    const filterItems = this.fieldDefRuleFilters
      ? Helper.sortDictArray(Helper.dictToArray(this.ruleFilters || []))
      : []
    const actionItems = this.fieldDefRuleActions
      ? Helper.sortDictArray(Helper.dictToArray(this.ruleActions || []))
      : []
    const stopItems = this.fieldDefRuleStops
      ? Helper.sortDictArray(Helper.dictToArray(this.ruleStops || []))
      : []

    return <div className={css(Styles.containerNarrow)}>
      {this.fieldDef && <Grid container>
        <Grid item xs={12} sm={12}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Automation Detail'} formDefinition={this.fieldDef}
            item={ruleItem}
            openModalForEdit={(current) => this.openModalForEditRule(current)}
          />
        </Grid>
      </Grid>}
      {this.fieldDefRuleFilters && this.rule && (filterItems.length > 0 || canAddSubEntities) && <Grid container className={css(Styles.subEntitySection)}>
        <Grid item xs={12} sm={12}>
          {filterItems.length > 0
            ? <SubEntityList
              title={'Entry Conditions'}
              tableHeadersMap={this.ruleFiltersTableHeadersMap}
              items={filterItems}
              subEntityHeaderActions={() => this.renderEntryConditionsHeaderActions(ruleItem)}
              subEntityActions={(current) => this.subEntityActions(current, this.fieldDefRuleFilters, 'filters')}
              noAdd={false}
              orderChangeEvent={this.state.orderChangeEvent}
              fetchState={this.state.fetchState}
              isOrderChanged={this.state.isOrderChanged}
              orderUp={(current, items, index) =>this.orderUp(current, items, index, {entityAttrName: 'filters'})}
              orderDown={(current, items, index) => this.orderDown(current, items, index, {entityAttrName: 'filters'})}
              orderUIMode={ApiHelper.ORDER_UI_MODE.INTERACTIVE}
              openModalForAdd={() => this.openModalForAddData(this.fieldDefRuleFilters, 'filters')}
            />
            : <Button variant='text' color='primary' className={css(Styles.emptySubEntityAdd)} onClick={() => this.openModalForAddData(this.fieldDefRuleFilters, 'filters')}>
              Add entry condition
            </Button>}
        </Grid>
      </Grid>}
      {this.fieldDefRuleActions && this.rule && (actionItems.length > 0 || canAddSubEntities) && <Grid container className={css(Styles.subEntitySection)}>
        <Grid item xs={12} sm={12}>
          {actionItems.length > 0
            ? <SubEntityList
              title={'Actions'}
              tableHeadersMap={this.ruleActionsTableHeadersMap}
              items={actionItems}
              subEntityActions={(current) => this.subEntityActions(current, this.fieldDefRuleActions, 'actions')}
              noAdd={false}
              orderChangeEvent={this.state.orderChangeEvent}
              fetchState={this.state.fetchState}
              isOrderChanged={this.state.isOrderChanged}
              orderUp={(current, items, index) =>this.orderUp(current, items, index, {entityAttrName: 'actions'})}
              orderDown={(current, items, index) => this.orderDown(current, items, index, {entityAttrName: 'actions'})}
              orderUIMode={ApiHelper.ORDER_UI_MODE.INTERACTIVE}
              openModalForAdd={() => this.openModalForAddData(this.fieldDefRuleActions, 'actions')}
            />
            : <Button variant='text' color='primary' className={css(Styles.emptySubEntityAdd)} onClick={() => this.openModalForAddData(this.fieldDefRuleActions, 'actions')}>
              Add action
            </Button>}
        </Grid>
      </Grid>}
      {this.fieldDefRuleStops && this.rule && (stopItems.length > 0 || canAddSubEntities) && <Grid container className={css(Styles.subEntitySection)}>
        <Grid item xs={12} sm={12}>
          {stopItems.length > 0
            ? <SubEntityList
              title={'Exit Conditions'}
              tableHeadersMap={this.ruleStopsTableHeadersMap}
              items={stopItems}
              subEntityHeaderActions={() => this.renderExitConditionsHeaderActions(ruleItem)}
              subEntityActions={(current) => this.subEntityActions(current, this.fieldDefRuleStops, 'stops')}
              noAdd={false}
              orderChangeEvent={this.state.orderChangeEvent}
              fetchState={this.state.fetchState}
              isOrderChanged={this.state.isOrderChanged}
              orderUp={(current, items, index) =>this.orderUp(current, items, index, {entityAttrName: 'stops'})}
              orderDown={(current, items, index) => this.orderDown(current, items, index, {entityAttrName: 'stops'})}
              orderUIMode={ApiHelper.ORDER_UI_MODE.INTERACTIVE}
              openModalForAdd={() => this.openModalForAddData(this.fieldDefRuleStops, 'stops')}
            />
            : <Button variant='text' color='primary' className={css(Styles.emptySubEntityAdd)} onClick={() => this.openModalForAddData(this.fieldDefRuleStops, 'stops')}>
              Add exit condition
            </Button>}
        </Grid>
      </Grid>}
      {!hideExecutionStatus && <div className={css(Styles.tableStatItem)}>
        <TableCard
          item={{data: report || {}, title: 'Execution Status', maxRows: this.limit}}
          showMoreInTable={true}
          nextPage={this.ruleJobsNextPage}
          nextPageState={this.state.executionStatusNextPageState || ApiHelper.State.READY}
          onNext={this.onExecutionStatusNextPage.bind(this)}
          cellWidths={this.executionStatusTableCellWidths}
          tableRowActions={this.executionStatusTableActions.bind(this)}/>
      </div>}
    </div>
  }

  async onExecutionStatusNextPage() {
    if (!this.ruleJobsNextPage || this.state.executionStatusNextPageState === ApiHelper.State.LOADING) {
      return
    }

    this.setState({ executionStatusNextPageState: ApiHelper.State.LOADING })
    try {
      const ruleJobsResult = await ApiHelper.callAwait({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath2({
          ms: this.ms,
          paths: ['rulejobs'],
          queryParams: {
            orgId: this.orgId,
            ruleId: this.ruleId,
            nextPage: this.ruleJobsNextPage,
            limit:this.limit
          }
        })
      })

      const nextItems = (ruleJobsResult && Array.isArray(ruleJobsResult.items)) ? ruleJobsResult.items : []
      this.ruleJobs = (this.ruleJobs || []).concat(nextItems)
      this.ruleJobsNextPage = ruleJobsResult && ruleJobsResult.nextPage
    } catch (e) {
      console.log(Helper.getErrorMsg(e))
    } finally {
      this.setState({ executionStatusNextPageState: ApiHelper.State.READY })
    }
  }

  executionStatusTableActions(headers, rows, rowIndex) {
    let entityId = null
    let entityType = null
    if(Array.isArray(rows) && rows[3]) {
      entityId = rows[3].entityId && CRMHelper.getUserIdFromEnityId(rows[3].entityId)
      entityType = rows[3].entityType
    }
    const actions = []

    if(entityId && entityType === 'CRMCONTACT') {
      actions.push(
        <Tooltip title={'View Contact'} classes={{ popper: css(Styles.tooltip) }}>
          <IconButton
            disableRipple
            className={css(AppStyles.entityTableLinkIcon)}
            onClick={() => window.open(`/admin/orgs/${this.orgId}/crm-contacts/${entityId}` , '_blank')}
          >
            <PersonOutlineOutlinedIcon style={{fontSize: 26}}/>
          </IconButton>
        </Tooltip>)
    }
    return actions
  }

  onOrderEdit(orderEditData, additionalData) {
    const { current, otherItem } = orderEditData
    if(current && otherItem && additionalData && additionalData.entityAttrName) {
      const apiPayload = {
        orgId: this.orgId,
        entityAction: 'edit',
        entityAttrName: additionalData.entityAttrName,
        id: current.id
      }

      const orderChangePayload = {
        current,
        otherItem,
        apiMethod: 'PUT',
        apiEndPoint: ApiHelper.makeUrlPath2({ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId}}),
        apiPayload
      }
      this.onOrderChange(orderChangePayload)
    }
  }

  openModalForAddData(fieldDef, entityAttrName) {
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'add'
    this.formDefinition.title = 'Add'

    let newOrder = '010'
    if(entityAttrName === 'filters' && this.ruleFilters) {
      newOrder = AppHelper.generateNewOrder(this.ruleFilters)
    } else if(entityAttrName === 'actions' && this.ruleActions) {
      newOrder = AppHelper.generateNewOrder(this.ruleActions)
    } else if(entityAttrName === 'stops' && this.ruleStops) {
      newOrder = AppHelper.generateNewOrder(this.ruleStops)
    }
    const orderField = Helper.getField(this.formDefinition, 'order')
    if(orderField) {
      orderField.defaultValue = newOrder
    }

    this.setState({
      apiMethod: 'PUT',
      apiData: { orgId: this.orgId, entityAction: 'add', entityAttrName: entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath2({ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId}}),
      modalOpen: true,
    },()=>{
      super.openModalForAdd(this.formDefinition)
    })
  }

  subEntityActions = (current, fieldDef, entityAttrName) => {
    const actions = []
    actions.push(<Tooltip title={'Edit section'} placement='top-start' key={current.id + 'editTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForEditData(current,fieldDef,entityAttrName)}>edit</i>
      </span>
    </Tooltip>)
    if(this.rule.state !== 'LIVE') {
      actions.push(<Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.openModalForDeleteData(current,fieldDef,entityAttrName)}>delete</i>
        </span>
      </Tooltip>)
    }
    return actions
  }

  renderEntryConditionsHeaderActions = (ruleItem) => {
    const selectedOp = (ruleItem && ruleItem.filtersOp) ? ruleItem.filtersOp : 'AND'
    return (
      <RadioGroup
        row
        value={selectedOp}
        onChange={(event) => this.updateRuleFiltersOp(event.target.value)}
        className={css(Styles.filtersOpActionsContainer)}
      >
        <FormControlLabel
          value='AND'
          control={<Radio color='primary' size='small' disabled={this.state.isUpdatingFiltersOp} />}
          label='AND'
          className={css(Styles.filtersOpActionLabel)}
        />
        <FormControlLabel
          value='OR'
          control={<Radio color='primary' size='small' disabled={this.state.isUpdatingFiltersOp} />}
          label='OR'
          className={css(Styles.filtersOpActionLabel)}
        />
      </RadioGroup>
    )
  }

  renderExitConditionsHeaderActions = (ruleItem) => {
    const selectedOp = (ruleItem && ruleItem.stopsOp) ? ruleItem.stopsOp : 'AND'
    return (
      <RadioGroup
        row
        value={selectedOp}
        onChange={(event) => this.updateRuleStopsOp(event.target.value)}
        className={css(Styles.filtersOpActionsContainer)}
      >
        <FormControlLabel
          value='AND'
          control={<Radio color='primary' size='small' disabled={this.state.isUpdatingStopsOp} />}
          label='AND'
          className={css(Styles.filtersOpActionLabel)}
        />
        <FormControlLabel
          value='OR'
          control={<Radio color='primary' size='small' disabled={this.state.isUpdatingStopsOp} />}
          label='OR'
          className={css(Styles.filtersOpActionLabel)}
        />
      </RadioGroup>
    )
  }

  async updateRuleFiltersOp(filtersOp) {
    if (!this.rule || !filtersOp || this.rule.filtersOp === filtersOp) {
      return
    }
    this.setState({
      isUpdatingFiltersOp: true,
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    })
    try {
      const apiEndPoint = ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId} })
      await ApiHelper.callAwait({
        method: 'PUT',
        endPoint: apiEndPoint,
        jsonBody: {
          orgId: this.orgId,
          filtersOp
        }
      })
      await this.fetchItems()
    } finally {
      this.setState({ isUpdatingFiltersOp: false })
    }
  }

  async updateRuleStopsOp(stopsOp) {
    if (!this.rule || !stopsOp || this.rule.stopsOp === stopsOp) {
      return
    }
    this.setState({
      isUpdatingStopsOp: true,
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    })
    try {
      const apiEndPoint = ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId} })
      await ApiHelper.callAwait({
        method: 'PUT',
        endPoint: apiEndPoint,
        jsonBody: {
          orgId: this.orgId,
          stopsOp
        }
      })
      await this.fetchItems()
    } finally {
      this.setState({ isUpdatingStopsOp: false })
    }
  }

  async updateRuleState(current, state) {
    const fields = [{
      key: 'state',
      label: 'Update state',
      type: 'edit_text',
      hint: 'Update state',
      v_required: { value: true, err: 'Provide update state' },
      placement: 'left',
      value: state,
      disabled: true,
    }]
    const tempFormDef = {
      formType: 'edit',
      title: 'Edit Rule State',
      steps: [{ fields }]
    }

    this.formDefinition = tempFormDef

    this.setState({
      apiMethod: 'PUT',
      apiData: { orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['rules', current.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true,
    }, () => {
      const currentWithState = { ...current, state }
      super.openModalForEdit(currentWithState, this.formDefinition)
    })
  }

  openModalForEditRule(current,fieldDef) {
    this.formDefinition = fieldDef || this.fieldDef
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = fieldDef && fieldDef.title || 'Edit Detail'
    if(!fieldDef) {
      Helper.populateFormDefinitionValues(this.formDefinition, current)
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: {orgId: this.orgId},
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['rules', current.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true,
    }, () => {
      super.openModalForEdit(current, this.formDefinition)
    });
  }

  openModalForEditData(current,fieldDef,entityAttrName,) {
    this.formDefinition = fieldDef
    const currentForEdit = CRMHelper.normalizeAutomationAssigneeCurrent(current)
    Helper.populateFormDefinitionValues(this.formDefinition, currentForEdit)
    this.setState({
      apiMethod: 'PUT',
      apiData: { orgId: this.orgId, entityAction: 'edit', entityAttrName: entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath2({ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId}}),
      modalOpen: true,
    },()=>{
      super.openModalForEdit(currentForEdit,this.formDefinition)
    })
  }

  openModalForDeleteData(current,fieldDef,entityAttrName) {
    this.formDefinition = fieldDef
    const currentForDelete = CRMHelper.normalizeAutomationAssigneeCurrent(current)
    Helper.populateFormDefinitionValues(this.formDefinition, currentForDelete)
    this.setState({
      apiMethod: 'PUT',
      apiData: { orgId: this.orgId, entityAction: 'del', entityAttrName: entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath2({ms: this.ms, paths: ['rules', this.rule.id], queryParams: {orgId: this.orgId}}),
      modalOpen: true,
    },()=>{
      super.openModalForDelete(currentForDelete,this.formDefinition)
    })
  }

  onCompleteAction(options) {
    this.setState({ modalOpen: false, dialogApiData: options && options.apiInvokeData })
    this.fetchItems()
  }

  async onFormFieldOptionAdd(options) {
    const { formField, value, formId } = options
    if (this.fieldDef.formId === formId) {
      formField.options.push({
        key: value,
        label: value
      })
      return formField.options || []
    }
    return []
  }

  customSubmit(options) {
    const { formData, formType, caller } = options
    const jsonBody = sanitizeAutomationDetailFormPayload(formData, formType)
    ApiHelper.call(
      { method: this.state.apiMethod, endPoint: this.state.apiEndPoint, jsonBody },
      (err, data) => {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err)
          caller.setState({ success: false, message: errorMessage, inProcess: false })
          return
        }
        caller.previousState = caller.state
        caller.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false,
        })
        if (caller.props.onCompleteAction) {
          caller.props.onCompleteAction({
            apiInvokeData: {
              method: this.state.apiMethod,
              endPoint: this.state.apiEndPoint,
              reqBody: jsonBody,
              responseBody: data,
            },
          })
        }
      }
    )
  }
}

const Styles = StyleSheet.create({
  tableStatItem: {
    flex: 1,
    minWidth: '100%',
    height: '100%',
    maxWidth: window.innerWidth - AppTheme.drawerWidth - (AppTheme.adminPagePadding * 2),
    '@media (max-width: 767px)': {
      width: '100%',
      alignSelf: 'center',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  line1: {
    fontSize: 16
  },
  line2: {
    fontSize: 14,
    color: 'gray'
  },
  spanValue: {
    fontSize: 14
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    // minHeight: 72,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'center',
    padding: '16px 5px',
    verticalAlign: 'middle',
    wordBreak: 'break-all',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    minWidth: 0,

    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '16px 2px',
    },
  },
  firstColumn: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    // overflowX: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  infoCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 2,
    fontSize: 16,
    minWidth: 0,
  },
  statusValueRow: {
    display: 'flex',
    alignItems: 'center'
  },
  preWrapText: {
    whiteSpace: 'pre-wrap',
  },
  imagePreview: {
    width: '100px',
    height: 'auto',
    display: 'block'
  },
  videoPreview: {
    width: '100px',
    height: 'auto',
    display: 'block'
  },
  imageWrapper: {
    display: 'block',
  },
  videoWrapper: {
    display: 'block',
  },
  subEntitySection: {
    width: '100%',
    alignSelf: 'stretch',
  },
  emptySubEntityAdd: {
    textTransform: 'none',
    paddingLeft: 0,
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 50,
    width: '100%',
    '@media (max-width: 767px)': {//TODO: next?
      //width: window.innerWidth - 20 //TODO: fix it, in product screen whitespace nowrap creating issue
    },
  },
  container: {
    background: 'white',
    border: CommonTheme.containerBorderColor,
    height: '100%',
    borderRadius: 16,
  },
  individualStatsHeaderContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  headingContent: {
    padding: '18px 5px 18px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media (max-width: 767px)': {
      padding: '18px 5px 18px 15px',
    }
  },
  individualStatsTitle: {
    color: CommonTheme.textColor,
    fontSize: 20,
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    marginRight: 10
  },
  content: {
    padding: '0px 30px',
    marginBottom: -3,
    '@media (max-width: 767px)': {
      padding: '0px 15px',
    }
  },
  errorDot: {
    backgroundColor: '#E53935',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 6,
    flexShrink: 0
  },
  warningDot: {
    backgroundColor: '#FF9800',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 6,
    flexShrink: 0
  },
  contentForRow: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  cellWidthSmall: {
    width: '10%',
    padding: '8px 5px',
  },
  cellWidthNormal: {
    width: '20%',
    padding: '8px 5px',
  },
  cellWidthWide: {
    width: '50%',
    padding: '8px 5px',
  },
  cellWidthUncapped: {
    maxWidth: 'none',
  },
  fullWidthWide: {
    width: '100%',
    padding: '8px 5px',
    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '5px 2px',
    },
  },
  tooltip: {
    zIndex: 9999999999
  },
  filtersOpActionsContainer: {
    marginRight: 8
  },
  filtersOpActionLabel: {
    marginRight: 8
  },
})